import { db } from '@/services/firebase'
import { collection, addDoc } from 'firebase/firestore'

export default {
  namespaced: true,

  state: {
    loading: false,
    error: null
  },

  mutations: {
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async recordDonation({ commit }, donationData) {
      commit('SET_LOADING', true)
      try {
        await addDoc(collection(db, 'donations'), donationData)
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
} 